import httpClient from './httpClient';

export const pointageService = {
  getLastestScan (start, end) {
    return httpClient.get(`/api/adv/telegestion/pointage/history/${start}/${end}`).then(
    )
  },

  getVitaphone () {
    return httpClient.get('/api/adv/telegestion/vitaphone').then(
    )
  },

  getCode () {
    return httpClient.get('/api/adv/telegestion/vitaphone/code').then(
    )
  }
}

export default pointageService;